import { Dashboard } from "@/components/dashboard/Dashboard/Dashboard";
import { VStack } from "@/components/layout/VStack";
import { HStack } from "@/components/layout/HStack";
import { useEffect, useState } from "react";
import { useMyExplorations } from "../hooks/myExplorations/useMyExplorations";
import { Skeleton } from "@/components/ui/Skeleton/Skeleton";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/Empty/Empty";
import { BookOpen, CalendarSync } from "lucide-react";
import { Button } from "@/components/ui/Button/Button";
import { Link } from "react-router-dom";
import { MyExplorations } from "../components/myExplorations/MyExplorationts";
import { ArchiveToggleButton } from "@/components/elements/ArchiveToggleButton/ArchiveToggleButton";

const StudentMyExplorations = ({
  archived = false,
}: {
  archived?: boolean;
}) => {
  const [explorations, setExplorations] = useState<{
    explorations: any[];
    rotations: any[];
    sessions: any[];
    teachers: any[];
  }>({
    explorations: [],
    rotations: [],
    sessions: [],
    teachers: [],
  });

  const { loadMyExplorations, loading } = useMyExplorations({ archived });

  useEffect(() => {
    loadMyExplorations(setExplorations);
  }, [archived]);

  return (
    <Dashboard
      activePage={archived ? "/explorations/me/archive" : "/explorations/me"}
    >
      <HStack justify="space-between" wrap>
        <VStack>
          <h2
            style={{
              fontSize: "var(--text-2xl)",
              lineHeight: "var(--line-height-2xl)",
              fontWeight: "var(--font-bold)",
            }}
          >
            {archived ? "Archived My Explorations" : "My Explorations"}
          </h2>
          <p style={{ color: "var(--muted-foreground)" }}>
            {archived
              ? "View archived explorations you were enrolled in."
              : "View the explorations you have enrolled in."}
          </p>
        </VStack>
        <ArchiveToggleButton />
      </HStack>
      {loading ? (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
            gap: "1rem",
          }}
        >
          {Array.from({ length: 6 }, (_, i) => (
            <Skeleton key={i} style={{ height: "240px", width: "100%" }} />
          ))}
        </div>
      ) : explorations.explorations.length < 1 ? (
        <Empty style={{ borderColor: "var(--secondary-border)" }}>
          <EmptyHeader>
            <EmptyMedia variant="icon">
              <BookOpen />
            </EmptyMedia>
            <EmptyTitle>
              {archived
                ? "No Archived Explorations"
                : "No Explorations Found"}
            </EmptyTitle>
            <EmptyDescription>
              {archived
                ? "There are no archived explorations you were enrolled in."
                : "There were no explorations found, if you believe this is an error, please refresh."}
            </EmptyDescription>
          </EmptyHeader>
          {!archived && (
            <EmptyContent>
              <Button asChild style={{ textDecoration: "none" }}>
                <Link to="/rotations">
                  <CalendarSync /> Sign Up
                </Link>
              </Button>
            </EmptyContent>
          )}
        </Empty>
      ) : (
        <MyExplorations data={explorations} />
      )}
    </Dashboard>
  );
};

export default StudentMyExplorations;
